import React from "react";

export default function useChk(marcados, setMarcados, data, checkOnlyOne) {
    const [allChecked, indeterminate] = React.useMemo(() => {
        if (!marcados || marcados.length === 0) return [false, false];
        if (marcados.length >= data.length) return [true, false];
        else return [false, true];
    }, [marcados]);

    const marcar = React.useCallback(
        (id, checked) => {
            setMarcados(marcados => {
                if (!checked)
                    return marcados.filter(x => x != id);
                else if (checkOnlyOne)
                    return [id];
                else return [...marcados, id];
            });
        },
        [setMarcados]
    );

    const checkAll = React.useCallback(() => { setMarcados(!allChecked ? data?.map(x => x.id) : []); }, [allChecked, data, setMarcados]);
    return { marcar, indeterminate, allChecked, checkAll };
}
